import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_ENT_CARRERAS,
  ALL_ENT_CARRERAS,
  LOADING_ALL_ENT_CARRERAS,
} from './EntMonedasReducer';
import {
  allEntMonedasService,
  deleteEntMonedasService,
  oneEntMonedasService,
  saveEntMonedasService,
} from './EntMonedasService';

export const allEntMonedasAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_ENT_CARRERAS, payload: true });
    const res = await allEntMonedasService(params);
    dispatch({ type: ALL_ENT_CARRERAS, payload: res.data });
    dispatch({ type: LOADING_ALL_ENT_CARRERAS, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_ENT_CARRERAS, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveEntMonedasAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveEntMonedasService(id, data);
    notify(res.data.message);
    await allEntMonedasAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoEntMonedasAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_ENT_CARRERAS, payload: data });
};

export const oneEntMonedasAction = async (dispatch, id) => {
  try {
    const res = await oneEntMonedasService(id);
    await setActivoEntMonedasAction(dispatch, res.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteEntMonedasAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteEntMonedasService(id);
    await setActivoEntMonedasAction(dispatch, null);
    notify(res.data.message);
    await allEntMonedasAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
